import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { colors } from '@startengine/design-system.theme.main';

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontWeight: '600',
  fontSize: '14px',
  lineHeight: '22px',
  textAlign: 'center',
  letterSpacing: '0.05px',
  fontFeatureSettings: 'pnum on, lnum on',
  textTransform: 'capitalize',
  color: `${theme.palette.common.midnight}`,
}));

export const TextBox = styled(Box)(
  () => `
    display: flex;
    align-items: center;
    height: 100%;
    position: relative;
  `,
);
export const TextBoxFixed = styled(Box)(
  ({ theme }) => `
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
    position: relative;
    &:hover { 
      :before {
        content: '';
        position: absolute;
        z-index: -1;
        border: 2px solid ${theme.palette.secondary.main};
        border-radius : 10px;
        left: 0;
        right: 0;
        bottom: 0px;
      }
    }
  `,
);

export const StyledContainer = styled(Box)(
  ({ theme }) => `
  display: flex;
  height: 100%;
  align-items: center;
  padding: 0 16px;
  .active-true {
    :before {
      content: '';
      z-index: -1;
      border: 2px solid ${theme.palette.secondary.main};
      border-radius : 10px;
      left: 0;
      right: 0;
      position: absolute;
      bottom: 0px;
    }
  }
`,
);

export const ContentText = styled(Typography)(({ theme }) => ({
  fontWeight: '500',
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '0.05px',
  color: ` ${theme.palette.common.midnight}`,
}));

export const TitleText = styled(Typography)(({ theme }) => ({
  fontWeight: '600',
  fontSize: '20px',
  lineHeight: '24px',
  letterSpacing: '0.05px',
  paddingBottom: '14px',
  color: theme.palette.secondary.main,
}));

export const StyledMenu = styled(Popover)(
  () => `
  bottom: auto;
  .MuiBackdrop-root {
    bottom: auto;
  }
  .MuiPaper-elevation {
    border-radius: 16px;
    position: inherit;
    box-shadow: 0px 66px 55px rgba(0, 0, 0, 0.08), 0px 27.5732px 22.9777px rgba(0, 0, 0, 0.04), 0px 14.742px 12.285px rgba(0, 0, 0, 0.0238443), 0px 8.26422px 6.88685px rgba(0, 0, 0, 0.02), 0px 4.38907px 3.65756px rgba(0, 0, 0, 0.0161557), 0px 1.82639px 1.52199px rgba(0, 0, 0, 0.0112458);
  }
  `,
);

export const ListItem = styled(Box)(() => ({
  alignItems: 'center',
  display: 'flex',
}));

export const StyledHover = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    backgroundColor: colors.gray5,
    cursor: 'pointer',
  },
  width: '86%',
  padding: '6px',
  borderRadius: '16px',
  marginBottom: '4px',
}));

export const ResetBox = styled(Box)(
  () => `
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  `,
);
